"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputTable = exports.InputTableField = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-non-null-assertion */
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var __1 = require("../..");
var nameFieldsBuilder_1 = require("../../nameFieldsBuilder");
var fieldMaker_1 = require("../fieldMaker");
require("./inputTable.css");
var InputTableField = /** @class */ (function (_super) {
    __extends(InputTableField, _super);
    function InputTableField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderHeader = function () {
            return (0, function_1.pipe)(O.fromNullable(_this.props.rowValue), O.match(function () { return _this.props.configuration.headers; }, function (rowValue) { return __spreadArray([
                _this.props.configuration.headers[0],
                { slug: 'rowValue', name: rowValue.headerName }
            ], _this.props.configuration.headers.slice(1), true); })).map(function (h, i) { return ((0, jsx_runtime_1.jsx)("th", __assign({ className: "header-elem", align: "center", style: { width: _this.getHeaderWith(i) } }, { children: h.name }), h.slug)); });
        };
        return _this;
    }
    InputTableField.prototype.getHeaderWith = function (index) {
        var _this = this;
        return "".concat((0, function_1.pipe)(O.fromNullable(this.props.rowValue), O.match(function () { return 100 / _this.props.configuration.headers.length; }, function (_) { return (index === 1 ? 13 : 87 / _this.props.configuration.headers.length); })), "%");
    };
    InputTableField.prototype.renderRows = function (headerSlug, valueSlugs) {
        var _this = this;
        return (0, function_1.pipe)(O.fromNullable(this.props.value), O.map(function (value) {
            return value.map(function (row, i) { return ((0, jsx_runtime_1.jsxs)("tr", __assign({ className: "row" }, { children: [(0, jsx_runtime_1.jsx)("td", __assign({ className: "row-title", align: "center" }, { children: row.data[headerSlug] })), (0, function_1.pipe)(O.fromNullable(_this.props.rowValue), O.match(function () { return ''; }, function (rowValue) { return ((0, jsx_runtime_1.jsx)("td", __assign({ align: "center" }, { children: (0, jsx_runtime_1.jsx)(__1.Form.ChoiceOption, { name: (0, nameFieldsBuilder_1.buildFieldName)(_this.props.name, row.data[headerSlug], rowValue.headerName), label: "", value: valueSlugs
                                .map(function (s) { return row.data[s]; })
                                .filter(function (v) { return v !== rowValue.defaultValue; }).length === 0
                                ? 1
                                : 0, type: "checkbox", disabled: row.disabled, onChange: function (_value, data) {
                                var v = __spreadArray([], _this.props.value.map(function (rowCurrent) {
                                    if (rowCurrent.data[headerSlug] !== row.data[headerSlug]) {
                                        return rowCurrent;
                                    }
                                    var slugH = _this.props.configuration.headers[0].slug;
                                    return {
                                        data: valueSlugs.reduce(function (c, s) {
                                            var _a;
                                            return (__assign(__assign({}, c), (_a = {}, _a[s] = data ? rowValue.defaultValue : 0, _a[slugH] = rowCurrent.data[slugH], _a)));
                                        }, {}),
                                        disabled: row.disabled,
                                    };
                                }), true);
                                _this.props.onChange && _this.props.onChange(v, v);
                            } }) }))); })), valueSlugs.map(function (vSlug) { return ((0, jsx_runtime_1.jsx)("td", __assign({ align: "center" }, { children: typeof row.data[vSlug] === 'string' ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "default-style" }, { children: row.data[vSlug] }))) : ((0, jsx_runtime_1.jsx)(__1.Form.Input, { name: (0, nameFieldsBuilder_1.buildFieldName)(_this.props.name, row.data[headerSlug], vSlug), type: "digits", disabled: row.disabled, value: row.data[vSlug], onChange: function (v) {
                                var vv = __spreadArray([], _this.props.value.map(function (c) {
                                    var _a;
                                    if (c.data[headerSlug] !== row.data[headerSlug]) {
                                        return c;
                                    }
                                    return __assign(__assign({}, row), { data: __assign(__assign({}, row.data), (_a = {}, _a[vSlug] = v ? parseFloat(v) : 0, _a)) });
                                }), true);
                                _this.props.onChange && _this.props.onChange(vv, vv);
                            } })) }), "".concat(row.data[headerSlug], "_").concat(vSlug))); })] }), "".concat(headerSlug, "-").concat(i))); });
        }), O.toNullable);
    };
    InputTableField.prototype.render = function () {
        var headersSlug = this.props.configuration.headers.map(function (h) { return h.slug; });
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "input-table" }, { children: (0, jsx_runtime_1.jsxs)("table", { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsx)("tr", __assign({ className: "input-table_header" }, { children: this.renderHeader() })) }), (0, jsx_runtime_1.jsx)("tbody", { children: this.renderRows(headersSlug[0], headersSlug.slice(1)) })] }) })));
    };
    return InputTableField;
}(React.PureComponent));
exports.InputTableField = InputTableField;
exports.InputTable = (0, fieldMaker_1.makeField)(InputTableField);
//# sourceMappingURL=inputTable.js.map